import React from 'react';

import { Button, Link } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import Trophy from 'components/icons/trophy';
import type { BoxProps } from 'components/ui';
import { Box } from 'components/ui';
import { Typography } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';
export const QuestCallToAction = Button.withConfig({
  backgroundColor: primitive.$meltyYellow,
  textDecorationColor: primitive.$meltyYellow,
  _text: {
    color: primitive.$bbqBrown,
  },
  _hover: {
    backgroundColor: '#E59900',
  },
  _pressed: {
    backgroundColor: '#CC8800',
  },
});

export const QuestBadgeIcon = Trophy.withConfig({
  height: '$3',
  marginRight: spacing.$0_5,
});

export const QuestBadgeText = Typography;

export const ImageWrapper = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.imageWrapper, style]} />
);

export const ReloadButton = Button.withConfig({
  variant: 'outline',
  borderColor: getDesignToken('border-color-error'),
  _text: {
    variant: 'copyTwo',
    fontSize: 'sm',
    color: getDesignToken('text-error'),
  },
});

export const QuestCardContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.cardContainer, style]} />
);

export const StyledLink = Link.withConfig({
  _web: { cursor: 'pointer' },
});

const styles = StyleSheet.create({
  imageWrapper: {
    alignItems: 'center',
    backgroundColor: getDesignToken('background-default'),
    height: spacing.$48,
    justifyContent: 'center',
  },
  cardContainer: {
    backgroundColor: getDesignToken('background-pattern'),
    borderRadius: primitive.$borderRadius,
    maxHeight: '100%',
    maxWidth: '100%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.15,
    shadowRadius: 2,
    width: '100%',
  },
});
